import { render, staticRenderFns } from "./CadastrarEditarSolicitacaoAcessoDialog.vue?vue&type=template&id=958a88fe"
import script from "./CadastrarEditarSolicitacaoAcessoDialog.vue?vue&type=script&lang=js"
export * from "./CadastrarEditarSolicitacaoAcessoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports